export const COUNTRIES = [
  { code: 'AF', name: 'Afghanistan' },
  { code: 'AL', name: 'Albania' },
  { code: 'AD', name: 'Andorra' },
  { code: 'DZ', name: 'Algeria' },
  { code: 'AO', name: 'Angola' },
  { code: 'AR', name: 'Argentina' },
  { code: 'AM', name: 'Armenia' },
  { code: 'AU', name: 'Australia' },
  { code: 'AT', name: 'Austria' },
  { code: 'AZ', name: 'Azerbaijan' },
  { code: 'BH', name: 'Bahrain' },
  { code: 'BD', name: 'Bangladesh' },
  { code: 'BY', name: 'Belarus' },
  { code: 'BE', name: 'Belgium' },
  { code: 'BZ', name: 'Belize' },
  { code: 'BJ', name: 'Benin' },
  { code: 'BO', name: 'Bolivia' },
  { code: 'BA', name: 'Bosnia and Herzegovina' },
  { code: 'BW', name: 'Botswana' },
  { code: 'BR', name: 'Brazil' },
  { code: 'BG', name: 'Bulgaria' },
  { code: 'KH', name: 'Cambodia' },
  { code: 'CM', name: 'Cameroon' },
  { code: 'CA', name: 'Canada' },
  { code: 'CL', name: 'Chile' },
  { code: 'CN', name: 'China' },
  { code: 'CO', name: 'Colombia' },
  { code: 'CR', name: 'Costa Rica' },
  { code: 'CI', name: 'Côte d\'Ivoire' },
  { code: 'HR', name: 'Croatia' },
  { code: 'CY', name: 'Cyprus' },
  { code: 'CZ', name: 'Czech Republic' },
  { code: 'DK', name: 'Denmark' },
  { code: 'DO', name: 'Dominican Republic' },
  { code: 'EC', name: 'Ecuador' },
  { code: 'EG', name: 'Egypt' },
  { code: 'SV', name: 'El Salvador' },
  { code: 'EE', name: 'Estonia' },
  { code: 'ET', name: 'Ethiopia' },
  { code: 'FI', name: 'Finland' },
  { code: 'FR', name: 'France' },
  { code: 'GE', name: 'Georgia' },
  { code: 'DE', name: 'Germany' },
  { code: 'GH', name: 'Ghana' },
  { code: 'GR', name: 'Greece' },
  { code: 'GT', name: 'Guatemala' },
  { code: 'HN', name: 'Honduras' },
  { code: 'HK', name: 'Hong Kong' },
  { code: 'HU', name: 'Hungary' },
  { code: 'IS', name: 'Iceland' },
  { code: 'IN', name: 'India' },
  { code: 'ID', name: 'Indonesia' },
  { code: 'IR', name: 'Iran' },
  { code: 'IQ', name: 'Iraq' },
  { code: 'IE', name: 'Ireland' },
  { code: 'IL', name: 'Israel' },
  { code: 'IT', name: 'Italy' },
  { code: 'JP', name: 'Japan' },
  { code: 'JO', name: 'Jordan' },
  { code: 'KZ', name: 'Kazakhstan' },
  { code: 'KE', name: 'Kenya' },
  { code: 'KR', name: 'South Korea' },
  { code: 'KW', name: 'Kuwait' },
  { code: 'LV', name: 'Latvia' },
  { code: 'LB', name: 'Lebanon' },
  { code: 'LY', name: 'Libya' },
  { code: 'LT', name: 'Lithuania' },
  { code: 'LU', name: 'Luxembourg' },
  { code: 'MO', name: 'Macao' },
  { code: 'MK', name: 'North Macedonia' },
  { code: 'MY', name: 'Malaysia' },
  { code: 'MT', name: 'Malta' },
  { code: 'MU', name: 'Mauritius' },
  { code: 'MX', name: 'Mexico' },
  { code: 'MD', name: 'Moldova' },
  { code: 'MA', name: 'Morocco' },
  { code: 'MZ', name: 'Mozambique' },
  { code: 'MM', name: 'Myanmar' },
  { code: 'NP', name: 'Nepal' },
  { code: 'NL', name: 'Netherlands' },
  { code: 'NZ', name: 'New Zealand' },
  { code: 'NG', name: 'Nigeria' },
  { code: 'NO', name: 'Norway' },
  { code: 'OM', name: 'Oman' },
  { code: 'PK', name: 'Pakistan' },
  { code: 'PS', name: 'Palestine' },
  { code: 'PA', name: 'Panama' },
  { code: 'PY', name: 'Paraguay' },
  { code: 'PE', name: 'Peru' },
  { code: 'PH', name: 'Philippines' },
  { code: 'PL', name: 'Poland' },
  { code: 'PT', name: 'Portugal' },
  { code: 'QA', name: 'Qatar' },
  { code: 'RO', name: 'Romania' },
  { code: 'RU', name: 'Russia' },
  { code: 'SA', name: 'Saudi Arabia' },
  { code: 'SN', name: 'Senegal' },
  { code: 'RS', name: 'Serbia' },
  { code: 'SG', name: 'Singapore' },
  { code: 'SK', name: 'Slovakia' },
  { code: 'SI', name: 'Slovenia' },
  { code: 'ZA', name: 'South Africa' },
  { code: 'ES', name: 'Spain' },
  { code: 'LK', name: 'Sri Lanka' },
  { code: 'SE', name: 'Sweden' },
  { code: 'CH', name: 'Switzerland' },
  { code: 'TW', name: 'Taiwan' },
  { code: 'TZ', name: 'Tanzania' },
  { code: 'TH', name: 'Thailand' },
  { code: 'TN', name: 'Tunisia' },
  { code: 'TR', name: 'Turkey' },
  { code: 'UG', name: 'Uganda' },
  { code: 'UA', name: 'Ukraine' },
  { code: 'AE', name: 'United Arab Emirates' },
  { code: 'GB', name: 'United Kingdom' },
  { code: 'US', name: 'United States' },
  { code: 'UY', name: 'Uruguay' },
  { code: 'UZ', name: 'Uzbekistan' },
  { code: 'VE', name: 'Venezuela' },
  { code: 'VN', name: 'Vietnam' },
  { code: 'YE', name: 'Yemen' },
  { code: 'ZM', name: 'Zambia' },
  { code: 'ZW', name: 'Zimbabwe' },
] as const;

// Service icons are handled via Lucide React components in the UI
// Note: ocean_freight, fcl, and lcl are treated as related services in filtering
// Searching for any of these will show forwarders offering any sea freight service
export const SERVICES = [
  { id: 'ocean_freight', name: 'Ocean Freight (FCL & LCL)', iconName: 'Ship' },
  { id: 'fcl', name: 'FCL (Full Container Load)', iconName: 'Ship' },
  { id: 'lcl', name: 'LCL (Less than Container Load)', iconName: 'Package' },
  { id: 'air_freight', name: 'Air Freight', iconName: 'Plane' },
  { id: 'road_freight', name: 'Road Freight', iconName: 'Truck' },
  { id: 'rail', name: 'Rail Freight', iconName: 'Train' },
  { id: 'express_courier', name: 'Express / Courier', iconName: 'Zap' },
  { id: 'hazardous_cargo', name: 'Hazardous Cargo', iconName: 'AlertTriangle' },
  { id: 'break_bulk', name: 'Break Bulk', iconName: 'Container' },
  { id: 'warehousing', name: 'Warehousing', iconName: 'Warehouse' },
  { id: 'temperature_controlled', name: 'Temperature Controlled', iconName: 'Snowflake' },
  { id: 'customs_clearance', name: 'Customs Clearance', iconName: 'FileCheck' },
] as const;

export const NETWORKS = [
  'WCA (World Cargo Alliance)',
  'FIATA',
  'JCtrans',
  'Globalia',
  'X2 Logistics Network',
  'Cargo Connections',
  'FreightNet',
  'Marcopololine',
  'GLN',
  'Other',
] as const;

export const CERTIFICATIONS = [
  'IATA Member',
  'IATA Certified Agent',
  'IATA CASS',
  'ISO 9001',
  'ISO 14001',
  'AEO (Authorized Economic Operator)',
  'C-TPAT',
  'TAPA',
  'GDP Certified',
  'Customs Broker License',
] as const;

// Certifications that support optional ID numbers
export const CERTIFICATIONS_WITH_ID = [
  'IATA Member',
  'IATA Certified Agent',
  'IATA CASS',
  'AEO (Authorized Economic Operator)',
  'C-TPAT',
] as const;

export const CARGO_SPECIALTIES = [
  { id: 'dangerous_goods', name: 'Dangerous Goods (DG)' },
  { id: 'temperature_controlled', name: 'Temperature-controlled / Pharma' },
  { id: 'project_cargo', name: 'Project Cargo / OOG' },
  { id: 'batteries', name: 'Batteries' },
  { id: 'high_value', name: 'High Value' },
  { id: 'ecommerce', name: 'Ecommerce / Courier' },
] as const;

export const FORWARDER_STRENGTHS = [
  { id: 'fast_response', name: 'Fast Response Time', iconName: 'Zap' },
  { id: 'competitive_rates', name: 'Competitive Rates', iconName: 'DollarSign' },
  { id: 'global_network', name: 'Global Network', iconName: 'Globe' },
  { id: 'dedicated_support', name: 'Dedicated Support', iconName: 'HeadphonesIcon' },
  { id: 'tech_enabled', name: 'Tech-Enabled', iconName: 'Laptop' },
  { id: 'customs_expertise', name: 'Customs Expertise', iconName: 'FileCheck' },
  { id: 'hazmat_certified', name: 'Hazmat Certified', iconName: 'AlertTriangle' },
  { id: 'temperature_control', name: 'Temperature Control', iconName: 'Thermometer' },
  { id: 'project_cargo', name: 'Project Cargo Specialist', iconName: 'Truck' },
  { id: 'ecommerce_fulfillment', name: 'E-commerce Fulfillment', iconName: 'Package' },
] as const;

export const SERVICE_COVERAGE = [
  { id: 'export', name: 'Export' },
  { id: 'import', name: 'Import' },
  { id: 'cross_trade', name: 'Cross-trade' },
] as const;

export const RESPONSE_SLA_OPTIONS = [
  { id: '2h', name: 'Within 2 hours' },
  { id: '6h', name: 'Within 6 hours' },
  { id: '24h', name: 'Within 24 hours' },
] as const;

export const LANGUAGES = [
  'English',
  'Mandarin Chinese',
  'Spanish',
  'German',
  'French',
  'Portuguese',
  'Russian',
  'Japanese',
  'Korean',
  'Arabic',
  'Hindi',
  'Italian',
  'Dutch',
  'Polish',
  'Turkish',
  'Vietnamese',
  'Thai',
  'Indonesian',
  'Other',
] as const;

export const TIMEZONES = [
  { id: 'UTC-12:00', name: 'UTC-12:00 (Baker Island)' },
  { id: 'UTC-11:00', name: 'UTC-11:00 (Samoa)' },
  { id: 'UTC-10:00', name: 'UTC-10:00 (Hawaii)' },
  { id: 'UTC-09:00', name: 'UTC-09:00 (Alaska)' },
  { id: 'UTC-08:00', name: 'UTC-08:00 (Pacific Time)' },
  { id: 'UTC-07:00', name: 'UTC-07:00 (Mountain Time)' },
  { id: 'UTC-06:00', name: 'UTC-06:00 (Central Time)' },
  { id: 'UTC-05:00', name: 'UTC-05:00 (Eastern Time)' },
  { id: 'UTC-04:00', name: 'UTC-04:00 (Atlantic Time)' },
  { id: 'UTC-03:00', name: 'UTC-03:00 (Brazil)' },
  { id: 'UTC-02:00', name: 'UTC-02:00 (Mid-Atlantic)' },
  { id: 'UTC-01:00', name: 'UTC-01:00 (Azores)' },
  { id: 'UTC+00:00', name: 'UTC+00:00 (London, Lisbon)' },
  { id: 'UTC+01:00', name: 'UTC+01:00 (CET - Paris, Berlin)' },
  { id: 'UTC+02:00', name: 'UTC+02:00 (EET - Athens, Cairo)' },
  { id: 'UTC+03:00', name: 'UTC+03:00 (Moscow, Istanbul)' },
  { id: 'UTC+04:00', name: 'UTC+04:00 (Dubai, Baku)' },
  { id: 'UTC+05:00', name: 'UTC+05:00 (Karachi)' },
  { id: 'UTC+05:30', name: 'UTC+05:30 (IST - India)' },
  { id: 'UTC+06:00', name: 'UTC+06:00 (Dhaka)' },
  { id: 'UTC+07:00', name: 'UTC+07:00 (Bangkok, Jakarta)' },
  { id: 'UTC+08:00', name: 'UTC+08:00 (Singapore, Hong Kong)' },
  { id: 'UTC+09:00', name: 'UTC+09:00 (Tokyo, Seoul)' },
  { id: 'UTC+10:00', name: 'UTC+10:00 (Sydney)' },
  { id: 'UTC+11:00', name: 'UTC+11:00 (Solomon Islands)' },
  { id: 'UTC+12:00', name: 'UTC+12:00 (Auckland)' },
] as const;

export const CONTACT_TITLES = [
  'Sales',
  'Operations',
  'Management',
  'Owner',
  'Director',
  'Manager',
  'Other',
] as const;
